import type { GoogleFreeBookingLinksHotelType } from "@/lib/gql/__generated__/graphql";

import type { ReactNode } from "react";

export const HOTEL_TYPE_OPTIONS: {
	value: GoogleFreeBookingLinksHotelType;
	label: string;
	description: ReactNode;
}[] = [
	{
		value: "hotel" as GoogleFreeBookingLinksHotelType,
		label: "ホテル・旅館",
		description: (
			<div className="space-y-4">
				<p>フロントデスクがある、もしくは管理スタッフが常駐している宿泊施設</p>
				<p className="text-sm">一般的なホテル、旅館、ビジネスホテル、リゾートホテルなどが該当します。</p>
			</div>
		),
	},
	{
		value: "vacation_rental" as GoogleFreeBookingLinksHotelType,
		label: "民泊",
		description: (
			<div className="space-y-4">
				<p>プライベートな貸切の家具付き宿泊施設</p>

				<div className="text-sm">
					<p>「ホテル・旅館」、「屋外宿泊施設」に該当しない場合も民泊として扱われます。</p>
					<p>アパート、一軒家、別荘、コテージなど、短期滞在用に管理・清掃される物件が該当します。</p>
				</div>
			</div>
		),
	},
	{
		value: "outdoor_lodging" as GoogleFreeBookingLinksHotelType,
		label: "屋外宿泊施設",
		description: (
			<div className="space-y-4">
				<p>テント用のオープンエリア、宿泊できるシンプルな屋根と壁のみの建築物を備えた宿泊施設</p>
				<p className="text-sm">キャンプ場、RVパーク、ハウスボートなどが該当します。</p>
			</div>
		),
	},
];
